<template>
<section v-if="carousel" :class="[block.class, 'has-text-centered', block.mode.toLowerCase()]" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <agile v-if="carousel.length > 0" :options="block.caro_config">
        <template v-for="item, i in carousel">
            <div class="page-hero__carousel-item">
                <component
                    :is="item.fulllink ? (item.cta && item.cta.button.is_internal && !item.cta.button.whitepaper? 'router-link' : 'a') : 'div'"
                    :target="item.cta && item.cta.button.open_in_blank ? '_blank' : null"
                    :to="item.cta && item.cta.button.is_internal ? item.cta.button.url : null"
                    :href="item.cta && !item.cta.button.is_internal ? item.cta.button.url : null"
                    :style="'background-image: url(' + item.background.image.url + ');'"
                    :class="[block.class, 'has-text-centered hero is-' + block.config.height, 'attachment-' + item.background.config.attachment, block.mode.toLowerCase()]"
                    @click="clickCaroItem((item.cta && item.cta.button.whitepaper) ? true : false, $event)"
                >
                    <div :class="['hero-body', {'is-tinty': item.background.config.tinty}, {'less-padding': item.hide_text}]">
                        <div :class="['container', item.alignment, {'is-flex is-justify-content-center': item.hide_text}]">
                            <h2 ref="title" :class="item.hide_text ? 'sr-only' : 'title'">{{item.title}}</h2>
                            <p v-if="item.content" :class="['subtitle', {'sr-only': item.hide_text}]" v-html="item.content"></p>
                            <p v-if="item.footer" :class="['footer-message', {'sr-only': item.hide_text}]">{{ item.footer }}</p>
                            <div :class="['cta', 'v-align-' + item.cta.config.v_alignment, {'is-marginless-top': item.hide_text}]" v-if="item.cta && item.cta.button">
                                <CTALink :link_data="item.cta" />
                            </div>
                        </div>
                        <div class="image-copyright has-text-white" v-if="item.background.image.copyright" v-html="item.background.image.copyright"></div>
                    </div>
                </component>
            </div>
        </template>
    </agile>
</section>
</template>

<script>
import { VueAgile } from 'vue-agile';
import CTALink from '../elements/CTALink';
export default {
    name: 'PageHeroCarouselMode',
    props: ['block'],
    components: {
        agile: VueAgile,
        CTALink: CTALink
    },
    computed    :   {
        carousel()
        {
            if (this.block && this.block.items) {
                return this.block.items;
            }
            return null;
        },
        marginstyle()
        {
            if (!this.top_margin) return null;

            return 'margin-top: ' + this.top_margin + 'px;';
        }
    },
    methods: {
        clickCaroItem(whitepaper, e) {
            if (whitepaper) {
                e.preventDefault()
                $(e.target).find('.cta button').click()
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.cta {
    margin-top: 3rem;
}

.container {
    &.is-flex {
        height: 100%;
    }
}

.agile {
    &__slide {
        height: 100%;
        .hero {
            height: 100%;
            .hero-body {
                height: 100%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/modules/herotypes/PageHeroCarouselMode.vue